import type { ServerResources } from '@frontend/types/adminhub';

async function authJson<T>(path: string, token: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(init?.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error((data as { message?: string }).message || `Request failed: ${response.status}`);
  }
  return data as T;
}

export async function fetchAdminSystemResources(token: string): Promise<ServerResources> {
  return authJson<ServerResources>('/api/admin/system-resources', token);
}

export async function deleteAdminProject(projectId: string, token: string): Promise<void> {
  await authJson(`/api/admin/projects/${encodeURIComponent(projectId)}`, token, { method: 'DELETE' });
}

export async function patchAdminProject(
  projectId: string,
  token: string,
  body: Record<string, unknown>,
): Promise<void> {
  await authJson(`/api/admin/projects/${encodeURIComponent(projectId)}`, token, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}
